export const environment = {
  production: true,
  environment: "ステージング環境",
  apiHost: "opca-api-stg.facere.biz",
  firebase: {
    apiKey: "AIzaSyCZ7yq4hRTbXxVHMkOG_ROaFCWnh1lIqcc",
    authDomain: "facere-opca-stg.firebaseapp.com",
    projectId: "facere-opca-stg",
    storageBucket: "facere-opca-stg.firebasestorage.app",
    messagingSenderId: "353129227158",
    appId: "1:353129227158:web:d008c7c6879c5f3e58b3b7",
    measurementId: "G-Q88HFZ4XJT"
  },
  googleAnalytics4ReportUrl: "https://lookerstudio.google.com/embed/reporting/27979c10-edeb-4254-a687-836d3f2c1ea3/page/tEnnC",
};
